module.exports = __webpack_public_path__ + "media/images/country_flags/af-1d1f8cfa5cb1032796c163b9efd39ce8.png";